import { render, staticRenderFns } from "./canceled_term.vue?vue&type=template&id=6d2cb36c&"
import script from "./canceled_term.vue?vue&type=script&lang=js&"
export * from "./canceled_term.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports